export default __webpack_public_path__ + "static/media/easy-cambodia-app-icon.051ecf7f.png";